import Vue from 'vue'
import {
  Button,
  Container,
  Row,
  Col,
  Icon,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Input,
  Aside,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Header,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Main,
  Steps,
  Step,
  Link,
  Breadcrumb,
  BreadcrumbItem,
  Avatar,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
  Pagination,
  Dialog,
  Radio,
  Checkbox,
  Tree,
  RadioGroup,
  Collapse,
  CollapseItem,
  DatePicker,
  Popover,
  CheckboxGroup,
  Progress,
  TimeSelect,
  Alert,
  Loading,
  Message,
  MessageBox,
  Notification,
  InputNumber,
  Autocomplete,
  Upload,
  Card,
  Image,
  Tag
} from 'element-ui'
import { deleteConfirm } from '@/utils/confirm.js'

Vue.use(Button)
Vue.use(Container)
Vue.use(Row)
Vue.use(Col)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Header)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Main)
Vue.use(Loading)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Link)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Avatar)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Tree)
Vue.use(RadioGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(CheckboxGroup)
Vue.use(Progress)
Vue.use(TimeSelect)
Vue.use(Alert)
Vue.use(Loading.directive);
Vue.use(InputNumber)
Vue.use(Autocomplete)
Vue.use(Upload);
Vue.use(Card);
Vue.use(Image);
Vue.use(Tag);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$deleteConfirm = deleteConfirm;
